import type { BoxProps, TileProps } from '@hover/blueprint';
import { Tile, VisuallyHidden, forwardRef, useRadio } from '@hover/blueprint';
import type { SkeletonProps, UseRadioProps } from '@hover/blueprint/chakra';
import type { ComponentProps } from 'react';
import React from 'react';

export interface PaletteTileProps
  extends Omit<TileProps, keyof UseRadioProps>,
    Omit<BoxProps, keyof UseRadioProps>,
    Pick<SkeletonProps, 'colorScheme'>,
    UseRadioProps {
  inputProps?: ComponentProps<'input'>;
}

export const PaletteTile = forwardRef<PaletteTileProps, 'div'>(
  ({ children, inputProps, tileProps, ...props }, ref) => {
    const {
      getLabelProps,
      getRootProps,
      getInputProps,
      state: { isChecked },
    } = useRadio(props);

    return (
      <Tile
        as="label"
        isSelected={isChecked}
        labelProps={getLabelProps()}
        noOfLabelLines={2}
        tileProps={{
          ...tileProps,
          aspectRatio: { base: '3/2', tablet: '1/1' },
          height: '100%',
        }}
        {...getRootProps()}
        {...props}
        ref={ref}
      >
        {children}
        <VisuallyHidden>
          <input {...getInputProps()} {...inputProps} />
        </VisuallyHidden>
      </Tile>
    );
  },
);
